import Vue from 'vue'
import DateRangePicker from '@/components/static/Inputs/DateRangePicker.vue'
import LocalidadeFilter from '@/components/static/Inputs/LocalidadeFilter.vue'
import ClassMultiSelectFilter from '@/components/static/Inputs/ClassMultiSelectFilter.vue'
import StatisticsChart from '@/components/static/Inputs/StatisticsChart.vue'

Vue.component('DateRangePicker', DateRangePicker)
Vue.component('LocalidadeFilter', LocalidadeFilter)
Vue.component('ClassMultiSelectFilter', ClassMultiSelectFilter)
Vue.component('StatisticsChart', StatisticsChart)
